import { OrderStatus } from "@/constants";
import { createBEM } from "@/libs";
import { ComponentBase } from "@/types";
import { dateFormat } from "@/utils/tool";
import { Icon } from "../Icon";
import "./index.scss";

export const TransactionStatusOnStep = {
  [OrderStatus.BUYER_REQUEST]: 2,
  [OrderStatus.SELLER_CANCELED_DEAL]: 2,

  [OrderStatus.WAITING_FOR_TRANSFER]: 3,
  [OrderStatus.BUYRER_CANCELD_DEAL]: 3,
  [OrderStatus.TIME_OVER]: 3,

  [OrderStatus.TRANSFERRED]: 4,
  [OrderStatus.SELLER_DID_NOT_RECEIVE]: 4,
  [OrderStatus.DISPUTING]: 4,
  [OrderStatus.CANCELED_BY_OFFICIAL]: 4,
  [OrderStatus.CONFIRMED_BY_OFFICIAL]: 4,
  [OrderStatus.DEAL]: 4,
  [OrderStatus.BUYER_NOT_APPEALS]: 4,
};

export const TransactionStrStatusOnStep = {
  [OrderStatus.BUYER_REQUEST]: "等待确认",

  [OrderStatus.SELLER_CANCELED_DEAL]: "交易取消",

  [OrderStatus.WAITING_FOR_TRANSFER]: "等待转账",
  [OrderStatus.BUYRER_CANCELD_DEAL]: "取消交易",
  [OrderStatus.TIME_OVER]: "超时取消",

  [OrderStatus.TRANSFERRED]: "等待转币",
  [OrderStatus.SELLER_DID_NOT_RECEIVE]: "卖家未收到款",
  [OrderStatus.DISPUTING]: "争议订单",
  [OrderStatus.CANCELED_BY_OFFICIAL]: "平台取消交易",
  [OrderStatus.CONFIRMED_BY_OFFICIAL]: "平台确认交易",
  [OrderStatus.DEAL]: "确认转币",
  [OrderStatus.BUYER_NOT_APPEALS]: "申诉期未申诉",
};

export interface TradeStepsProps extends ComponentBase.Component {
  status: OrderStatus;
  createTime: string;
}

export const TradeSteps = ({ status, createTime }: TradeStepsProps) => {
  const b = createBEM("trade-steps");

  const step = TransactionStatusOnStep[status];

  const step2 =
    TransactionStatusOnStep[status] === 2
      ? TransactionStrStatusOnStep[status]
      : "已确认";

  const step3 =
    TransactionStatusOnStep[status] === 3
      ? TransactionStrStatusOnStep[status]
      : "已转账";

  const step4 =
    TransactionStatusOnStep[status] === 4
      ? TransactionStrStatusOnStep[status]
      : "确认转币";

  const target = <span className={b("target")}></span>;

  return (
    <div className={b()}>
      <div className={b("item", "first")}>
        <div className={b("up")}>{dateFormat(createTime, "M/D")}</div>
        <div className={b("icon-area")}>
          <Icon
            className={b("target-past")}
            name="step-success"
            size="20px"
          />
        </div>
        <div className={b("down")}>{dateFormat(createTime, "h:m:s")}</div>
      </div>
      <div className={b("item", { onstep: step === 2, past: step > 2 })}>
        <div className={b("up")}>卖家确认交易</div>
        <div className={b("icon-area")}>
          {step > 2 ? (
            <Icon
              className={b("target-past")}
              name="step-success"
              size="20px"
            />
          ) : (
            target
          )}
        </div>
        {step >= 2 && <div className={b("down")}>{step2}</div>}
      </div>
      <div className={b("item", { onstep: step === 3, past: step > 3 })}>
        <div className={b("up")}>买家转账</div>
        <div className={b("icon-area")}>
          {step > 3 ? (
            <Icon
              className={b("target-past")}
              name="step-success"
              size="20px"
            />
          ) : (
            target
          )}
        </div>
        {step >= 3 && <div className={b("down")}>{step3}</div>}
      </div>
      <div
        className={b("item", "last", {
          onstep: step === 4,
          past:
            OrderStatus.CONFIRMED_BY_OFFICIAL === status ||
            OrderStatus.DEAL === status,
        })}
      >
        <div className={b("up")}>交易完成</div>
        <div className={b("icon-area")}>
          {OrderStatus.CONFIRMED_BY_OFFICIAL === status ||
          OrderStatus.DEAL === status ? (
            <Icon
              className={b("target-past")}
              name="step-success"
              size="20px"
            />
          ) : (
            target
          )}
        </div>
        {step >= 4 && <div className={b("down")}>{step4}</div>}
      </div>
    </div>
  );
};
